var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScanQr(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18068_182520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.492 100.189C191.485 119.456 177.713 136.636 159.705 147.632C150.112 153.491 139.316 157.593 128.457 159.324C109.091 162.409 88.4313 158.119 71.3157 147.632C57.5104 139.173 46.0106 126.68 39.3576 110.772C25.364 77.3141 37.6477 40.3306 61.4557 20.0764C80.897 3.53984 113.846 -6.80451 131.501 5.21819C142.975 13.0327 138.174 23.6083 154.942 40.4848C168.236 53.8635 176.434 52.4339 184.971 64.7641C195.298 79.6836 193.826 96.9867 193.493 100.189H193.492Z",
    fill: "#FDF1DC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_18068_182520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.459 33.3368C133.184 32.6912 135.921 34.378 136.566 37.1036L155.865 118.533C156.511 121.259 154.823 123.994 152.098 124.64L68.7606 144.39C66.0348 145.036 63.2996 143.349 62.6539 140.623L43.3576 59.1919C42.7117 56.4635 44.3986 53.7299 47.1243 53.0842L130.459 33.3368Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.21442
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1091 130.108L73.7012 130.916L74.509 134.324L77.9169 133.516L77.1091 130.108Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5173 129.302L77.1094 130.109L77.9172 133.517L81.3251 132.71L80.5173 129.302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9275 128.493L80.5195 129.301L81.3273 132.709L84.7353 131.901L83.9275 128.493Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3298 127.686L83.9219 128.494L84.7297 131.902L88.1377 131.094L87.3298 127.686Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7419 126.878L87.334 127.686L88.1418 131.094L91.5498 130.286L90.7419 126.878Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5564 125.263L94.1484 126.07L94.9562 129.478L98.3642 128.67L97.5564 125.263Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.963 124.454L97.5547 125.262L98.3625 128.67L101.77 127.862L100.963 124.454Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.187 122.03L107.779 122.838L108.587 126.246L111.995 125.438L111.187 122.03Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.203 120.369L114.594 121.225L115.402 124.633L119.011 123.777L118.203 120.369Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.611 119.561L118.203 120.369L119.011 123.777L122.419 122.969L121.611 119.561Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.426 117.946L125.018 118.754L125.825 122.162L129.233 121.354L128.426 117.946Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.834 117.138L128.426 117.945L129.234 121.353L132.642 120.545L131.834 117.138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.24 116.331L131.832 117.139L132.64 120.547L136.048 119.739L135.24 116.331Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.648 115.522L135.24 116.33L136.048 119.738L139.456 118.93L138.648 115.522Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.058 114.714L138.65 115.521L139.458 118.929L142.866 118.122L142.058 114.714Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.664 113.861L142.055 114.717L142.862 118.125L146.472 117.269L145.664 113.861Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7068 130.917L70.2988 131.725L71.1066 135.133L74.5146 134.325L73.7068 130.917Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9314 123.47L86.5234 124.277L87.3312 127.685L90.7392 126.877L89.9314 123.47Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.156 121.046L96.748 121.854L97.5559 125.261L100.964 124.454L100.156 121.046Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.97 119.432L103.562 120.24L104.37 123.648L107.778 122.84L106.97 119.432Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.381 118.624L106.973 119.432L107.78 122.84L111.188 122.032L110.381 118.624Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.785 117.815L110.377 118.623L111.185 122.031L114.593 121.223L113.785 117.815Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.393 116.961L113.783 117.816L114.591 121.224L118.2 120.369L117.393 116.961Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.617 114.538L124.209 115.346L125.017 118.754L128.425 117.946L127.617 114.538Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.861 110.453L141.252 111.309L142.06 114.717L145.669 113.861L144.861 110.453Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8962 127.509L69.4883 128.316L70.2961 131.724L73.7041 130.917L72.8962 127.509Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9041 122.485L75.4961 123.293L76.3039 126.701L79.7119 125.893L78.9041 122.485Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3064 121.677L78.8984 122.484L79.7062 125.892L83.1142 125.085L82.3064 121.677Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1267 120.063L85.7188 120.871L86.5266 124.279L89.9345 123.471L89.1267 120.063Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9392 118.446L92.5312 119.254L93.3391 122.662L96.747 121.854L95.9392 118.446Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3474 117.639L95.9395 118.447L96.7473 121.855L100.155 121.047L99.3474 117.639Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.754 116.833L99.3457 117.641L100.154 121.049L103.561 120.241L102.754 116.833Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.572 115.216L106.164 116.023L106.972 119.431L110.38 118.624L109.572 115.216Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.978 114.407L109.57 115.215L110.378 118.623L113.786 117.815L112.978 114.407Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.588 113.553L112.979 114.408L113.786 117.816L117.396 116.961L116.588 113.553Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.996 112.747L116.588 113.555L117.396 116.963L120.804 116.155L119.996 112.747Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.81 111.13L123.402 111.938L124.21 115.345L127.618 114.538L126.81 111.13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.625 109.516L130.217 110.324L131.025 113.732L134.433 112.924L133.625 109.516Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.035 108.706L133.627 109.514L134.435 112.922L137.843 112.114L137.035 108.706Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.051 107.045L140.441 107.9L141.249 111.308L144.859 110.453L144.051 107.045Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0857 124.102L68.6777 124.91L69.4855 128.318L72.8935 127.51L72.0857 124.102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0935 119.077L74.6855 119.885L75.4934 123.293L78.9013 122.485L78.0935 119.077Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5017 118.268L78.0938 119.076L78.9016 122.484L82.3095 121.676L81.5017 118.268Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3162 116.653L84.9082 117.461L85.716 120.869L89.124 120.061L88.3162 116.653Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1345 115.04L91.7266 115.848L92.5344 119.256L95.9423 118.448L95.1345 115.04Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.947 113.425L98.5391 114.232L99.3469 117.64L102.755 116.833L101.947 113.425Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.761 111.805L105.354 112.613L106.161 116.021L109.569 115.213L108.761 111.805Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.004 107.721L122.596 108.529L123.404 111.937L126.811 111.129L126.004 107.721Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.818 106.106L129.41 106.914L130.218 110.322L133.626 109.514L132.818 106.106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.226 105.3L132.818 106.107L133.626 109.515L137.034 108.708L136.226 105.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.244 103.635L139.635 104.49L140.443 107.898L144.052 107.043L143.244 103.635Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2771 120.694L67.8691 121.502L68.677 124.91L72.0849 124.102L71.2771 120.694Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5095 113.247L84.1016 114.055L84.9094 117.463L88.3173 116.655L87.5095 113.247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.324 111.634L90.916 112.441L91.7238 115.849L95.1318 115.042L94.324 111.634Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7322 110.825L94.3242 111.633L95.132 115.041L98.54 114.233L97.7322 110.825Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.142 110.016L97.7344 110.824L98.5422 114.232L101.95 113.424L101.142 110.016Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.953 108.401L104.545 109.209L105.353 112.617L108.761 111.809L107.953 108.401Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.359 107.596L107.951 108.404L108.759 111.812L112.167 111.004L111.359 107.596Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.381 105.929L114.973 106.736L115.78 110.144L119.188 109.336L118.381 105.929Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.199 104.315L121.791 105.123L122.599 108.531L126.007 107.723L125.199 104.315Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.436 100.228L138.826 101.084L139.634 104.492L143.243 103.636L142.436 100.228Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4705 117.288L67.0625 118.096L67.8703 121.504L71.2783 120.696L70.4705 117.288Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.072 113.071L69.6641 113.879L70.4719 117.287L73.8798 116.479L73.072 113.071Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4802 112.264L73.0723 113.072L73.8801 116.48L77.288 115.672L76.4802 112.264Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8865 111.454L76.4785 112.262L77.2863 115.67L80.6943 114.862L79.8865 111.454Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2927 110.647L79.8848 111.455L80.6926 114.863L84.1005 114.055L83.2927 110.647Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.699 109.837L83.291 110.645L84.0988 114.052L87.5068 113.245L86.699 109.837Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5154 108.225L90.1074 109.033L90.9152 112.441L94.3232 111.633L93.5154 108.225Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.332 106.608L96.9238 107.416L97.7316 110.824L101.14 110.016L100.332 106.608Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.74 105.802L100.332 106.609L101.14 110.017L104.548 109.21L103.74 105.802Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.552 104.184L107.145 104.992L107.952 108.4L111.36 107.592L110.552 104.184Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.388 100.907L120.98 101.715L121.788 105.123L125.196 104.315L124.388 100.907Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.795 100.098L124.387 100.906L125.195 104.314L128.602 103.506L127.795 100.098Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.203 99.2898L127.795 100.098L128.603 103.506L132.011 102.698L131.203 99.2898Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.611 98.4852L131.203 99.293L132.011 102.701L135.419 101.893L134.611 98.4852Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.017 97.6746L134.609 98.4824L135.417 101.89L138.825 101.083L138.017 97.6746Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.629 96.8202L138.02 97.6758L138.827 101.084L142.437 100.228L141.629 96.8202Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6638 113.878L66.2559 114.686L67.0637 118.094L70.4716 117.286L69.6638 113.878Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.933 102.393L99.5254 103.201L100.333 106.609L103.741 105.801L102.933 102.393Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.34 101.585L102.932 102.393L103.739 105.801L107.147 104.993L106.34 101.585Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.748 100.776L106.34 101.584L107.148 104.992L110.556 104.184L109.748 100.776Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.765 99.1141L113.357 99.9219L114.165 103.33L117.573 102.522L116.765 99.1141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4568 106.257L68.0488 107.064L68.8566 110.472L72.2646 109.665L71.4568 106.257Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.863 105.446L71.4551 106.254L72.2629 109.662L75.6708 108.854L74.863 105.446Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2693 104.639L74.8613 105.447L75.6691 108.855L79.0771 108.047L78.2693 104.639Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6775 103.831L78.2695 104.639L79.0773 108.047L82.4853 107.239L81.6775 103.831Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9021 101.409L88.4941 102.217L89.302 105.625L92.7099 104.817L91.9021 101.409Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3103 100.6L91.9023 101.408L92.7102 104.816L96.1181 104.008L95.3103 100.6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7166 99.7957L95.3086 100.604L96.1164 104.011L99.5244 103.204L98.7166 99.7957Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.535 98.1766L102.127 98.9844L102.935 102.392L106.343 101.585L105.535 98.1766Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.941 97.368L105.533 98.1758L106.341 101.584L109.749 100.776L108.941 97.368Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.547 96.5155L108.938 97.3711L109.745 100.779L113.355 99.9235L112.547 96.5155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.959 95.7059L112.551 96.5137L113.359 99.9216L116.767 99.1138L115.959 95.7059Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.363 94.9012L115.955 95.709L116.763 99.1169L120.171 98.3091L119.363 94.9012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.773 94.0926L119.365 94.9004L120.173 98.3084L123.581 97.5005L122.773 94.0926Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.181 93.2859L122.773 94.0938L123.581 97.5017L126.989 96.6939L126.181 93.2859Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.588 92.4754L126.18 93.2832L126.987 96.6912L130.395 95.8834L129.588 92.4754Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.404 90.8582L132.996 91.666L133.804 95.074L137.212 94.2662L136.404 90.8582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.01 90.0058L136.4 90.8613L137.208 94.2693L140.818 93.4137L140.01 90.0058Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0564 102.04L70.6484 102.848L71.4562 106.256L74.8642 105.448L74.0564 102.04Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4646 101.231L74.0566 102.039L74.8645 105.447L78.2724 104.639L77.4646 101.231Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6853 98.8094L84.2773 99.6172L85.0852 103.025L88.4931 102.217L87.6853 98.8094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0935 98.0027L87.6855 98.8105L88.4934 102.219L91.9013 101.411L91.0935 98.0027Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9099 96.3855L94.502 97.1934L95.3098 100.601L98.7177 99.7935L97.9099 96.3855Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.133 93.9637L104.725 94.7715L105.532 98.1794L108.94 97.3716L108.133 93.9637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.148 92.2977L111.74 93.1055L112.548 96.5134L115.956 95.7056L115.148 92.2977Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.556 91.493L115.148 92.3008L115.956 95.7087L119.364 94.9009L118.556 91.493Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.371 89.8777L121.963 90.6855L122.771 94.0935L126.179 93.2857L125.371 89.8777Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.777 89.0691L125.369 89.877L126.177 93.2849L129.585 92.4771L128.777 89.0691Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8396 99.4402L66.4316 100.248L67.2395 103.656L70.6474 102.848L69.8396 99.4402Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6541 97.825L73.2461 98.6328L74.0539 102.041L77.4619 101.233L76.6541 97.825Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0662 97.0164L76.6582 97.8242L77.466 101.232L80.874 100.424L80.0662 97.0164Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4724 96.2078L80.0645 97.0156L80.8723 100.424L84.2802 99.6158L83.4724 96.2078Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8787 95.4012L83.4707 96.209L84.2785 99.6169L87.6865 98.8091L86.8787 95.4012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6951 93.7879L90.2871 94.5957L91.0949 98.0037L94.5029 97.1959L93.6951 93.7879Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1013 92.9773L93.6934 93.7852L94.5012 97.1931L97.9091 96.3853L97.1013 92.9773Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.508 92.1707L97.0996 92.9785L97.9074 96.3865L101.315 95.5787L100.508 92.1707Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.92 91.3641L100.512 92.1719L101.32 95.5798L104.727 94.772L103.92 91.3641Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.322 90.5535L103.914 91.3613L104.722 94.7693L108.13 93.9615L107.322 90.5535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.934 89.6972L107.324 90.5527L108.132 93.9607L111.741 93.1051L110.934 89.6972Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.97 85.6609L124.562 86.4688L125.37 89.8767L128.778 89.0689L127.97 85.6609Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.379 84.8523L127.971 85.6602L128.779 89.0681L132.186 88.2603L131.379 84.8523Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.399 83.1893L134.789 84.0449L135.597 87.4529L139.206 86.5973L138.399 83.1893Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4334 100.247L63.0254 101.055L63.8332 104.463L67.2412 103.655L66.4334 100.247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0349 96.0301L65.627 96.8379L66.4348 100.246L69.8427 99.438L69.0349 96.0301Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4412 95.2254L69.0332 96.0332L69.841 99.4412L73.249 98.6334L72.4412 95.2254Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8455 94.4188L72.4375 95.2266L73.2453 98.6345L76.6533 97.8267L75.8455 94.4188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4783 91.1883L86.0703 91.9961L86.8781 95.4041L90.2861 94.5962L89.4783 91.1883Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8845 90.3777L89.4766 91.1855L90.2844 94.5935L93.6923 93.7857L92.8845 90.3777Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.515 87.1473L103.107 87.9551L103.915 91.363L107.323 90.5552L106.515 87.1473Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.941 84.6766L113.533 85.4844L114.341 88.8923L117.749 88.0845L116.941 84.6766Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.347 83.8699L116.939 84.6777L117.747 88.0857L121.155 87.2779L120.347 83.8699Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.166 82.2527L123.758 83.0605L124.566 86.4685L127.974 85.6607L127.166 82.2527Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.574 81.4461L127.166 82.2539L127.974 85.6619L131.382 84.8541L130.574 81.4461Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.98 80.6375L130.572 81.4453L131.38 84.8533L134.788 84.0455L133.98 80.6375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.592 79.7811L133.982 80.6367L134.79 84.0447L138.4 83.1891L137.592 79.7811Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6248 96.8406L62.2168 97.6484L63.0246 101.056L66.4326 100.249L65.6248 96.8406Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0388 91.0086L71.6309 91.8164L72.4387 95.2244L75.8466 94.4166L75.0388 91.0086Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4451 90.2L75.0371 91.0078L75.8449 94.4158L79.2529 93.608L78.4451 90.2Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8533 89.3914L78.4453 90.1992L79.2531 93.6072L82.6611 92.7994L81.8533 89.3914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2654 88.5887L81.8574 89.3965L82.6652 92.8044L86.0732 91.9966L85.2654 88.5887Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6716 87.7781L85.2637 88.5859L86.0715 91.9939L89.4794 91.1861L88.6716 87.7781Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0779 86.9715L88.6699 87.7793L89.4777 91.1873L92.8857 90.3794L92.0779 86.9715Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.299 84.5477L98.8906 85.3555L99.6984 88.7634L103.106 87.9556L102.299 84.5477Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.724 82.0789L109.316 82.8867L110.124 86.2947L113.532 85.4869L112.724 82.0789Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.135 81.2684L112.727 82.0762L113.534 85.4841L116.942 84.6763L116.135 81.2684Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.767 78.0379L126.359 78.8457L127.167 82.2537L130.575 81.4459L129.767 78.0379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8181 93.4324L61.4102 94.2402L62.218 97.6482L65.6259 96.8404L64.8181 93.4324Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4158 89.2195L64.0078 90.0273L64.8156 93.4353L68.2236 92.6275L67.4158 89.2195Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8259 88.409L67.418 89.2168L68.2258 92.6248L71.6337 91.8169L70.8259 88.409Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2322 87.6004L70.8242 88.4082L71.632 91.8162L75.04 91.0084L74.2322 87.6004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6404 86.7918L74.2324 87.5996L75.0402 91.0076L78.4482 90.1998L77.6404 86.7918Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4548 85.1785L81.0469 85.9863L81.8547 89.3943L85.2626 88.5865L84.4548 85.1785Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2673 83.5633L87.8594 84.3711L88.6672 87.7791L92.0751 86.9712L91.2673 83.5633Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6794 82.7566L91.2715 83.5645L92.0793 86.9724L95.4873 86.1646L94.6794 82.7566Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.494 81.1395L98.0859 81.9473L98.8937 85.3552L102.302 84.5474L101.494 81.1395Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.9 80.3309L101.492 81.1387L102.3 84.5466L105.708 83.7388L104.9 80.3309Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.51 79.4765L104.9 80.332L105.708 83.74L109.318 82.8844L108.51 79.4765Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.918 78.6687L108.51 79.4766L109.318 82.8845L112.726 82.0767L111.918 78.6687Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.734 77.0496L115.326 77.8574L116.134 81.2654L119.542 80.4576L118.734 77.0496Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.138 76.2449L118.73 77.0527L119.538 80.4607L122.946 79.6529L122.138 76.2449Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.551 75.4383L122.143 76.2461L122.95 79.6541L126.358 78.8462L125.551 75.4383Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.957 74.6297L125.549 75.4375L126.357 78.8455L129.765 78.0376L128.957 74.6297Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.973 72.9686L132.363 73.8242L133.171 77.2322L136.781 76.3766L135.973 72.9686Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6052 85.8113L63.1973 86.6191L64.0051 90.0271L67.413 89.2193L66.6052 85.8113Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4236 84.1922L70.0156 85L70.8234 88.408L74.2314 87.6001L73.4236 84.1922Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.238 82.5789L76.8301 83.3867L77.6379 86.7947L81.0458 85.9869L80.238 82.5789Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6443 81.7742L80.2363 82.582L81.0441 85.99L84.4521 85.1822L83.6443 81.7742Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8689 79.3465L90.4609 80.1543L91.2687 83.5623L94.6767 82.7544L93.8689 79.3465Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2771 78.5398L93.8691 79.3477L94.677 82.7556L98.0849 81.9478L97.2771 78.5398Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.687 77.7313L97.2793 78.5391L98.0871 81.947L101.495 81.1392L100.687 77.7313Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.703 76.0683L104.094 76.9238L104.902 80.3318L108.511 79.4762L107.703 76.0683Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.111 75.2605L107.703 76.0684L108.511 79.4763L111.919 78.6685L111.111 75.2605Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.519 74.452L111.111 75.2598L111.919 78.6677L115.327 77.8599L114.519 74.452Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.334 72.8406L117.926 73.6484L118.734 77.0564L122.142 76.2486L121.334 72.8406Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.146 71.2215L124.738 72.0293L125.546 75.4373L128.954 74.6294L128.146 71.2215Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.558 70.4129L128.15 71.2207L128.958 74.6287L132.366 73.8209L131.558 70.4129Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.162 69.5565L131.553 70.4121L132.361 73.8201L135.97 72.9645L135.162 69.5565Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2029 86.618L59.7949 87.4258L60.6027 90.8337L64.0107 90.0259L63.2029 86.618Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7986 82.4012L62.3906 83.209L63.1984 86.6169L66.6064 85.8091L65.7986 82.4012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4314 79.1707L76.0234 79.9785L76.8312 83.3865L80.2392 82.5787L79.4314 79.1707Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8376 78.3621L79.4297 79.1699L80.2375 82.5779L83.6455 81.7701L82.8376 78.3621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6521 76.7488L86.2441 77.5566L87.052 80.9646L90.4599 80.1568L89.6521 76.7488Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0642 75.9402L89.6562 76.748L90.4641 80.156L93.872 79.3482L93.0642 75.9402Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8787 74.327L96.4707 75.1348L97.2785 78.5427L100.686 77.7349L99.8787 74.327Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.289 73.5164L99.8809 74.3242L100.689 77.7322L104.097 76.9244L103.289 73.5164Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.302 71.8523L106.895 72.6602L107.702 76.0681L111.11 75.2603L110.302 71.8523Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.709 71.0438L110.301 71.8516L111.109 75.2595L114.517 74.4517L113.709 71.0438Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.119 70.2371L113.711 71.0449L114.519 74.4529L117.927 73.6451L117.119 70.2371Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.527 69.4305L117.119 70.2383L117.927 73.6462L121.335 72.8384L120.527 69.4305Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.933 68.6219L120.525 69.4297L121.333 72.8376L124.741 72.0298L123.933 68.6219Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.342 67.8133L123.934 68.6211L124.741 72.0291L128.149 71.2212L127.342 67.8133Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3923 83.2117L58.9844 84.0195L59.7922 87.4275L63.2001 86.6197L62.3923 83.2117Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8513 73.3406L85.4434 74.1484L86.2512 77.5564L89.6591 76.7486L88.8513 73.3406Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6638 71.7234L92.2559 72.5312L93.0637 75.9392L96.4716 75.1314L95.6638 71.7234Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.072 70.9168L95.6641 71.7246L96.4719 75.1326L99.8798 74.3248L99.072 70.9168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.088 69.2558L102.479 70.1113L103.286 73.5193L106.896 72.6637L106.088 69.2558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.496 68.4422L106.088 69.25L106.896 72.658L110.304 71.8501L109.496 68.4422Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.9 67.6414L109.492 68.4492L110.3 71.8572L113.708 71.0494L112.9 67.6414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1873 75.5848L60.7793 76.3926L61.5871 79.8005L64.9951 78.9927L64.1873 75.5848Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5955 74.7781L64.1875 75.5859L64.9953 78.9939L68.4033 78.1861L67.5955 74.7781Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0017 73.9715L67.5938 74.7793L68.4016 78.1873L71.8095 77.3794L71.0017 73.9715Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4119 73.1609L71.0039 73.9688L71.8117 77.3767L75.2197 76.5689L74.4119 73.1609Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8162 72.3543L74.4082 73.1621L75.216 76.5701L78.624 75.7623L77.8162 72.3543Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6345 70.7391L81.2266 71.5469L82.0344 74.9548L85.4423 74.147L84.6345 70.7391Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0408 69.9324L84.6328 70.7402L85.4406 74.1482L88.8486 73.3404L88.0408 69.9324Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2615 67.5086L94.8535 68.3164L95.6613 71.7244L99.0693 70.9166L98.2615 67.5086Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.094 64.2313L108.686 65.0391L109.493 68.447L112.901 67.6392L112.094 64.2313Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.504 63.4207L112.096 64.2285L112.904 67.6365L116.311 66.8287L115.504 63.4207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.318 61.8074L118.91 62.6152L119.718 66.0232L123.126 65.2154L122.318 61.8074Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.742 59.3378L129.133 60.1934L129.941 63.6013L133.55 62.7457L132.742 59.3378Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7771 76.3953L57.3691 77.2031L58.177 80.6111L61.5849 79.8033L60.7771 76.3953Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0095 68.948L73.6016 69.7559L74.4094 73.1638L77.8173 72.356L77.0095 68.948Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.471 62.4374L100.861 63.293L101.669 66.7009L105.279 65.8454L104.471 62.4374Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.877 61.6316L104.469 62.4395L105.277 65.8474L108.685 65.0396L107.877 61.6316Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.695 60.0164L111.287 60.8242L112.095 64.2322L115.503 63.4244L114.695 60.0164Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.101 59.2078L114.693 60.0156L115.501 63.4236L118.909 62.6158L118.101 59.2078Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.916 57.5926L121.508 58.4004L122.316 61.8084L125.724 61.0005L124.916 57.5926Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.326 56.784L124.918 57.5918L125.726 60.9998L129.134 60.1919L128.326 56.784Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.936 55.9257L128.326 56.7812L129.134 60.1892L132.743 59.3336L131.936 55.9257Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9705 72.9852L56.5625 73.793L57.3703 77.2009L60.7783 76.3931L59.9705 72.9852Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9783 67.9637L62.5703 68.7715L63.3781 72.1794L66.7861 71.3716L65.9783 67.9637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3865 67.1551L65.9785 67.9629L66.7863 71.3709L70.1943 70.563L69.3865 67.1551Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2009 65.5398L72.793 66.3477L73.6008 69.7556L77.0087 68.9478L76.2009 65.5398Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0173 63.9207L79.6094 64.7285L80.4172 68.1365L83.8251 67.3287L83.0173 63.9207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4255 63.116L83.0176 63.9238L83.8254 67.3318L87.2333 66.524L86.4255 63.116Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.24 61.5027L89.832 62.3105L90.6398 65.7185L94.0478 64.9107L93.24 61.5027Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6462 60.6922L93.2383 61.5L94.0461 64.908L97.4541 64.1001L96.6462 60.6922Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.662 59.0311L100.053 59.8867L100.861 63.2947L104.47 62.4391L103.662 59.0311Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.297 55.7996L113.889 56.6074L114.696 60.0154L118.104 59.2076L117.297 55.7996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.707 54.9891L117.299 55.7969L118.107 59.2048L121.515 58.397L120.707 54.9891Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.109 54.1844L120.701 54.9922L121.509 58.4001L124.917 57.5923L124.109 54.1844Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1658 69.5809L55.7578 70.3887L56.5656 73.7966L59.9736 72.9888L59.1658 69.5809Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1697 64.5555L61.7617 65.3633L62.5695 68.7712L65.9775 67.9634L65.1697 64.5555Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5798 63.7469L65.1719 64.5547L65.9797 67.9626L69.3876 67.1548L68.5798 63.7469Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3943 62.1316L71.9863 62.9395L72.7941 66.3474L76.2021 65.5396L75.3943 62.1316Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2087 60.5145L78.8008 61.3223L79.6086 64.7302L83.0166 63.9224L82.2087 60.5145Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0232 58.9031L85.6152 59.7109L86.423 63.1189L89.831 62.3111L89.0232 58.9031Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4294 58.0945L89.0215 58.9023L89.8293 62.3103L93.2373 61.5025L92.4294 58.0945Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8357 57.2859L92.4277 58.0938L93.2355 61.5017L96.6435 60.6939L95.8357 57.2859Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2478 56.4793L95.8398 57.2871L96.6477 60.6951L100.056 59.8873L99.2478 56.4793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.856 55.621L99.2461 56.4766L100.054 59.8845L103.663 59.0289L102.856 55.621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.672 54.0047L106.264 54.8125L107.071 58.2205L110.479 57.4126L109.672 54.0047Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.078 53.2L109.67 54.0078L110.478 57.4158L113.886 56.608L113.078 53.2Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.49 52.3934L113.082 53.2012L113.89 56.6091L117.298 55.8013L116.49 52.3934Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.304 50.7762L119.896 51.584L120.704 54.9919L124.112 54.1841L123.304 50.7762Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.711 49.9695L123.303 50.7773L124.111 54.1853L127.519 53.3775L126.711 49.9695Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.32 49.1132L126.711 49.9688L127.519 53.3767L131.128 52.5211L130.32 49.1132Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3552 66.1707L54.9473 66.9785L55.7551 70.3865L59.163 69.5787L58.3552 66.1707Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5837 58.7234L71.1758 59.5312L71.9836 62.9392L75.3916 62.1314L74.5837 58.7234Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2166 55.491L84.8086 56.2988L85.6164 59.7068L89.0244 58.899L88.2166 55.491Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6228 54.6863L88.2148 55.4941L89.0227 58.9021L92.4306 58.0943L91.6228 54.6863Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4373 53.0711L95.0293 53.8789L95.8371 57.2869L99.2451 56.4791L98.4373 53.0711Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.051 52.2147L98.4414 53.0703L99.2492 56.4783L102.859 55.6227L102.051 52.2147Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.459 51.4051L102.051 52.2129L102.859 55.6209L106.267 54.813L105.459 51.4051Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.865 50.6004L105.457 51.4082L106.265 54.8162L109.673 54.0084L108.865 50.6004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.902 46.5613L122.494 47.3691L123.302 50.7771L126.71 49.9693L125.902 46.5613Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5447 62.7645L54.1367 63.5723L54.9445 66.9802L58.3525 66.1724L57.5447 62.7645Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1462 58.5477L56.7383 59.3555L57.5461 62.7634L60.9541 61.9556L60.1462 58.5477Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5544 57.741L60.1465 58.5488L60.9543 61.9568L64.3623 61.149L63.5544 57.741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9607 56.9324L63.5527 57.7402L64.3605 61.1482L67.7685 60.3404L66.9607 56.9324Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3709 56.1238L66.9629 56.9316L67.7707 60.3396L71.1787 59.5318L70.3709 56.1238Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7771 55.3152L70.3691 56.123L71.177 59.531L74.5849 58.7232L73.7771 55.3152Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5916 53.7L77.1836 54.5078L77.9914 57.9158L81.3994 57.108L80.5916 53.7Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9998 52.8953L80.5918 53.7031L81.3996 57.1111L84.8076 56.3033L83.9998 52.8953Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.244 48.8085L97.6348 49.6641L98.4426 53.072L102.052 52.2164L101.244 48.8085Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.056 47.1902L104.648 47.998L105.456 51.406L108.864 50.5982L108.056 47.1902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.873 45.575L111.465 46.3828L112.273 49.7908L115.681 48.983L114.873 45.575Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.277 44.7684L114.869 45.5762L115.677 48.9841L119.085 48.1763L118.277 44.7684Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.701 42.3007L125.092 43.1562L125.9 46.5642L129.509 45.7086L128.701 42.3007Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.738 59.3543L53.3301 60.1621L54.1379 63.5701L57.5458 62.7623L56.738 59.3543Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.234 143.898L86.8496 121.619L124.272 114.519L163.607 122.245L143.234 143.898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.364 144.554C143.241 144.578 143.111 144.569 142.988 144.519L86.6033 122.239C86.3256 122.129 86.1547 121.849 86.1827 121.553C86.2107 121.257 86.4358 121.018 86.7253 120.959L124.148 113.861C124.231 113.844 124.318 113.846 124.402 113.862L163.737 121.586C163.975 121.634 164.17 121.806 164.245 122.038C164.32 122.271 164.263 122.524 164.096 122.701L143.723 144.355C143.626 144.458 143.499 144.527 143.366 144.553L143.364 144.554ZM89.2449 121.846L143.058 143.108L162.29 122.667L124.269 115.203L89.2449 121.846Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.824 131.602C136.847 137.65 140.762 142.261 143.229 143.897L164.006 157.674C173.416 163.476 174.46 166.142 178.288 171.671L204.293 209.224C209.372 216.56 214.985 223.515 221.084 230.028L227.599 236.988C229.574 239.096 232.77 239.501 235.207 237.95C237.646 236.398 238.633 233.327 237.555 230.643L235.373 225.217C232.568 218.237 229.334 211.439 225.688 204.861L200.526 159.441L199.226 154.874C195.141 137.051 181.629 127.905 181.629 127.905C161.258 113.186 142.823 131.598 142.823 131.598L142.824 131.602Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.825 131.603C142.825 131.603 151.002 123.452 162.479 122.339C166.557 122.345 170.717 123.474 174.471 126.583C174.834 126.884 182.788 135.913 184.227 139.095C187.044 145.332 182.159 148.81 176.486 147.727C160.311 144.64 146.255 136.788 141.125 133.668C141.573 133 142.126 132.312 142.827 131.602L142.825 131.603Z",
    fill: "#EDB755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.47 139.262C177.461 137.616 174.786 134.186 170.494 131.601C166.203 129.016 161.92 128.254 160.928 129.9C159.937 131.547 162.612 134.977 166.904 137.562C171.195 140.147 175.478 140.908 176.47 139.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.288 239.432C231.081 239.869 228.728 239.171 227.116 237.448L220.601 230.488C214.499 223.971 208.829 216.945 203.748 209.607L177.742 172.054C177.28 171.387 176.859 170.76 176.457 170.165C173.561 165.867 171.814 163.274 163.659 158.245L142.863 144.456C142.053 143.919 139.384 141.909 139.04 138.6C138.784 136.127 139.898 133.614 142.349 131.134C142.349 131.134 142.351 131.133 142.353 131.131C142.546 130.938 147.145 126.396 154.349 123.614C161.031 121.035 171.257 119.591 182.024 127.37C182.146 127.451 195.785 136.859 199.882 154.731L201.152 159.188L226.279 204.541C229.922 211.117 233.194 217.993 235.999 224.973L238.181 230.398C239.38 233.38 238.281 236.793 235.571 238.518C234.857 238.973 234.081 239.278 233.289 239.434L233.288 239.432ZM143.301 132.074C141.145 134.256 140.159 136.405 140.372 138.46C140.654 141.185 142.917 142.883 143.601 143.338L164.378 157.114C172.759 162.283 174.672 165.119 177.564 169.414C177.962 170.003 178.382 170.626 178.841 171.288L204.846 208.841C209.891 216.124 215.519 223.099 221.575 229.569L228.09 236.529C229.843 238.402 232.685 238.76 234.849 237.384C237.015 236.006 237.893 233.276 236.936 230.893L234.754 225.467C231.969 218.538 228.722 211.714 225.104 205.184L199.942 159.766C199.917 159.721 199.899 159.673 199.883 159.625L198.583 155.06C194.599 137.683 181.388 128.552 181.255 128.463C172.984 122.488 164.098 121.278 154.828 124.861C147.934 127.523 143.404 131.969 143.297 132.075L143.301 132.074Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.556 130.838C116.33 130.883 116.084 130.81 115.921 130.622L113.007 127.284C112.765 127.006 112.792 126.584 113.072 126.339C113.35 126.096 113.772 126.124 114.017 126.403L116.931 129.741C117.174 130.019 117.146 130.441 116.866 130.686C116.775 130.766 116.667 130.816 116.556 130.838Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.755 142.518C126.529 142.563 126.283 142.49 126.12 142.301L123.206 138.964C122.964 138.686 122.992 138.264 123.271 138.018C123.549 137.776 123.971 137.804 124.216 138.083L127.13 141.42C127.373 141.698 127.345 142.121 127.066 142.366C126.974 142.446 126.867 142.496 126.755 142.518Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.697 141.572C112.471 141.617 112.227 141.544 112.062 141.358C111.82 141.08 111.848 140.657 112.125 140.413L115.458 137.496C115.735 137.251 116.16 137.28 116.403 137.558C116.645 137.836 116.618 138.259 116.34 138.503L113.008 141.42C112.916 141.5 112.808 141.55 112.697 141.572Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.365 131.363C124.139 131.407 123.895 131.334 123.73 131.148C123.488 130.87 123.515 130.448 123.793 130.203L127.125 127.286C127.403 127.043 127.826 127.071 128.07 127.348C128.313 127.626 128.285 128.049 128.008 128.293L124.675 131.21C124.584 131.29 124.476 131.341 124.365 131.363Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.893 112.486C159.796 112.506 159.692 112.504 159.59 112.476L157.703 111.969C157.345 111.872 157.134 111.506 157.231 111.148C157.327 110.791 157.694 110.58 158.051 110.674L159.938 111.182C160.296 111.278 160.507 111.645 160.412 112.002C160.343 112.257 160.137 112.438 159.895 112.486L159.893 112.486Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.495 114.262C166.397 114.281 166.294 114.279 166.191 114.252L164.304 113.744C163.947 113.648 163.736 113.281 163.832 112.924C163.929 112.566 164.295 112.355 164.652 112.45L166.54 112.957C166.897 113.054 167.108 113.42 167.014 113.777C166.945 114.032 166.739 114.213 166.497 114.261L166.495 114.262Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.119 117.366C161.022 117.385 160.918 117.383 160.816 117.356C160.459 117.26 160.246 116.893 160.342 116.536L160.846 114.649C160.942 114.292 161.309 114.081 161.666 114.175C162.023 114.272 162.236 114.638 162.14 114.996L161.636 116.882C161.569 117.137 161.362 117.318 161.119 117.366Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.883 110.763C162.786 110.782 162.682 110.78 162.58 110.752C162.222 110.656 162.009 110.29 162.106 109.932L162.609 108.046C162.706 107.688 163.072 107.477 163.43 107.572C163.787 107.668 164 108.035 163.903 108.392L163.4 110.279C163.333 110.533 163.125 110.715 162.883 110.763Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18068_182520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 240,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_18068_182520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107.795,
    height: 106.125,
    fill: "white",
    transform: "translate(41 41.0605) rotate(-5.3551)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanQr);
export default __webpack_public_path__ + "static/media/scan_qr.c4876e289f18614695c05dc720ddecb3.svg";
export { ForwardRef as ReactComponent };